import DefaultError from "@ext/errorHandlers/logic/DefaultError";
import t from "@ext/localization/locale/translate";
import getBpmnDiagram from "@ext/markdown/elements/diagrams/diagrams/bpmn/getBpmnDiagram";
import getMermaidDiagram from "@ext/markdown/elements/diagrams/diagrams/mermaid/getMermaidDiagram";
import getPlantUmlDiagram from "@ext/markdown/elements/diagrams/diagrams/plantUml/getPlantUmlDiagram";
import DiagramType from "./DiagramType";

export default class Diagrams {
	constructor(private _diagramRendererServerUrl: string) {}

	async getDiagram(type: DiagramType, content: string): Promise<string> {
		switch (type) {
			case DiagramType["plant-uml"]:
				return getPlantUmlDiagram(content, this._diagramRendererServerUrl);
			case DiagramType.mermaid:
				return getMermaidDiagram(content);
			case DiagramType.bpmn:
				return getBpmnDiagram(content);
			default:
				throw new DefaultError(t("diagram.error.wrong-name"), new Error(`unknown diagram type: ${type}`));
		}
	}
}
